const tab_cart = () =>
    import ( /* webpackChunkName: "tabbar-cart" */ '@/views/order/tabbar-cart.vue');
const PlaceOrderEntity = () =>
    import ( /* webpackChunkName: "placerder-entity" */ '@/views/order/place-order-entity/');
const PlaceOrderVirtual = () =>
    import ( /* webpackChunkName: "placeOrder-virtual" */ '@/views/order/place-order-virtual/');
const Payment = () =>
    import ( /* webpackChunkName: "payment" */ '@/views/order/payment/');
const PaymentStatus = () =>
    import ( /* webpackChunkName: "payment-status" */ '@/views/order/payment-status/');
const PaymentDuiGongStatus = () =>
    import ( /* webpackChunkName: "payment-duigong-status" */ '@/views/order/payment-duigong-status/');

const Tabbar = () =>
    import ( /* webpackChunkName: "Tabbar" */ '@/vue/components/Tabbar/');
const Subscriptions = () =>
    import ( /* webpackChunkName: "subscriptions" */ '@/views/order/subscriptions/index.vue');
    
export default [{
    path: "/order",
    name: "cart",
    components: { default: tab_cart, tabbar: Tabbar }
}, {
    path: "/order/placeOrderEntity",
    name: "placeOrderEntity",
    meta: {
        keepAlive: true,
        hideMenu: true
    },
    component: PlaceOrderEntity
}, {
    path: "/order/placeOrderVirtual",
    name: "placeOrderVirtual",
    meta: {
        hideMenu: true
    },
    component: PlaceOrderVirtual
}, {
    path: "/order/payment/:order_id",
    name: "payment",
    meta: {
        hideMenu: true
    },
    component: Payment
}, {
    path: "/order/paymentstatus/:id",
    name: "paymentStatus",
    component: PaymentStatus,
    props: true
}, {
    path: "/order/duigong/paymentstatus/:id",
    name: 'paymentDuiGongStatus',
    component: PaymentDuiGongStatus
}, {
    path: "/order/subscriptions",
    name: 'subscriptions',
    meta: {
        hideMenu: true
    },
    component: Subscriptions
}]